'use client'

import * as React from 'react'
import * as PopoverPrimitive from '@radix-ui/react-popover'

import { cn } from '@ui/lib/utils'

function Popover({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Root>) {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />
}

function PopoverTrigger({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Trigger>) {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />
}

function PopoverContent({
  className,
  align = 'center',
  sideOffset = 4,
  withPortal,
  animate = true,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content> & {
  withPortal?: boolean
  animate?: boolean
}) {
  const content = (
    <PopoverPrimitive.Content
      data-slot="popover-content"
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'origin-(--radix-popover-content-transform-origin) outline-hidden z-50 flex w-[100vw] max-w-[600px] flex-col gap-xs rounded-lg border',
        'border-gray-200 bg-white px-none py-xs text-gray-950 shadow-[0_0_12px_0_var(--alpha-black-10)] data-[state=closed]:zoom-out-95',
        'data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2',
        'data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        className,
        animate &&
          'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
      )}
      {...props}
    />
  )

  if (withPortal) {
    return <PopoverPrimitive.Portal>{content}</PopoverPrimitive.Portal>
  }

  return content
}

function PopoverAnchor({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Anchor>) {
  return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />
}

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor }
